import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../../store'
import { updateTemplate } from '../../../store/templatesTechSupport/actions'
import { IStore } from '../../../store/types'
import { TamplateForm } from '../../../components/Templates/TamplateForm'
import { ITemplate } from '../../../store/templatesTechSupport/types'
import { TypeTemplates } from '../../../utils/consts'

export const TechEditTamplate: React.FC = () => {
  const [template, setTemplate] = React.useState<ITemplate | null>(null)

  const { id } = useParams()

  const { templatesTechSupport } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (id && templatesTechSupport.currentGroup) {
      const template = templatesTechSupport.currentGroup.templates.find((template) => template.absnum === Number(id))
      if (template) {
        setTemplate(template)
      }
    }
  }, [id, templatesTechSupport.currentGroup])

  const handleCreate = (
    values: { group_id?: number | undefined; product_id: number; message: string },
    callback: (success: boolean) => void
  ) => {
    dispatch(
      updateTemplate({
        id: Number(id),
        data: { ...values, is_type: TypeTemplates.SUPPORT },
      })
    ).then((res) => {
      if (res.meta.requestStatus !== 'fulfilled') {
        callback(false)
      } else {
        callback(true)
      }
    })
  }

  if (!templatesTechSupport.currentGroup || !template) return null

  return (
    <TamplateForm
      title={`Група ${templatesTechSupport.currentGroup.name}. Шаблон`}
      data={template}
      groupId={templatesTechSupport.currentGroup.absnum}
      createTemplate={handleCreate}
    />
  )
}
